import c from './confirm-export-bar.vue';

export default c;
